<template lang='pug'>
  section.cadastro-territorio-paraguai
      BaseHeader(:titulo="$t('mensagens.territorio.titulo')", :exibeBotao='false', :voltarPara='true')

      .view-container-base-header
          .row.m-0
              h2.section-title-info-cadastro.pb-1 {{ $t('mensagens.territorio.informacoesCadastrais') }}
              el-form.formContainer.w-100.mb-4
                span.titulo-informacao {{ $t('mensagens.territorio.labels.dadosPropriedade') }}
                .form-alignment
                    el-form-item.form-size.separator.custon-label.my-3(
                        v-if='ff1183CodigoLyraTerritorio && territorio.codigoLyra',
                        :rules='[{ required: true, trigger: "blur" }]'
                    )
                        div.localidades-territorio-paraguai
                            div.select-flex-60
                                div
                                    span.titulo-territorio {{ $t('mensagens.territorio.labels.nomeFazenda') }}
                                el-input(
                                    v-model='territorio.nome',
                                    @blur='$v.territorio.nome.$touch()',
                                    :placeholder="$t('mensagens.territorio.labels.nomeFazenda')",
                                    :class='{ "error-border": $v.territorio.nome.$error }',
                                    maxlength='250'
                                )
                                .error(
                                    v-if='$v.territorio.nome.$error && !$v.territorio.nome.required'
                                ) {{ $t('mensagens.territorio.nomeNecessario') }}
                            div.select-flex.ml-4
                                div
                                    span {{ this.$t('mensagens.territorio.labels.codigoLyra') }}
                                    el-input(
                                        v-model='territorio.codigoLyra',
                                        disabled=true
                                    )
                    el-form-item.form-size.separator.custon-label.my-3(
                        v-else,
                        :rules='[{ required: true, trigger: "blur" }]'
                    )
                        div.localidades-territorio-paraguai
                            div.form-size
                                div
                                    span.titulo-territorio {{ $t('mensagens.territorio.labels.nomeFazenda') }}
                                el-input(
                                    v-model='territorio.nome',
                                    @blur='$v.territorio.nome.$touch()',
                                    :placeholder="$t('mensagens.territorio.labels.nomeFazenda')",
                                    :class='{ "error-border": $v.territorio.nome.$error }',
                                    maxlength='250'
                                )
                                .error(
                                    v-if='$v.territorio.nome.$error && !$v.territorio.nome.required'
                                ) {{ $t('mensagens.territorio.nomeNecessario') }}

                el-form-item.form-size.separator.custon-label.my-3
                    span.titulo-informacao {{ $t('mensagens.territorio.labels.localidade') }}
                    div.localidades-territorio-paraguai
                        div.select-flex
                            div
                                span {{ this.$t('mensagens.blocoFiltros.uteis.paraguaiNivel1') }}
                            el-select(
                                v-model='localidadeNivel1Selecionada',
                                filterable,
                                value-key='id',
                                @change='buscarLocalidadeNivel2()',
                                :placeholder='$t("mensagens.comuns.selecione")',
                                :disabled="isEdicaoSimplesTerritorio"
                            )
                                el-option(
                                    v-for='(localidadeNivel1, index) in localidadesNivel1',
                                    :key='index',
                                    :label='localidadeNivel1.nome',
                                    :value='localidadeNivel1'
                                ) {{ localidadeNivel1.nome }}

                        div.select-flex.ml-4
                            div
                                span {{ this.$t('mensagens.blocoFiltros.uteis.paraguaiNivel2') }}
                            el-select(
                                v-model='localidadeNivel2Selecionada',
                                filterable,
                                value-key='id',
                                :placeholder='$t("mensagens.comuns.selecione")',
                                @change="buscarLocalizacao",
                                :disabled="isEdicaoSimplesTerritorio"
                            )
                                el-option(
                                    v-for='(localidadeNivel2, index) in localidadesNivel2',
                                    :key='index',
                                    :label='localidadeNivel2.nome',
                                    :value='localidadeNivel2'
                                ) {{ localidadeNivel2.nome }}

                InformacaoAgricola(
                    v-if='dataLoaded',
                    :informacaoSelected='territorio.informacoesAgricolas'
                )

          .row.m-0
              h2.section-title-info-cadastro.pb-1 {{ $t('mensagens.territorio.vincularPessoa.vincularPessoa') }}
              VincularPessoa.mb-4.col-12.no-padding(
                  ref="vincularPessoa"
                  :representantesSelecionados="representantesSelecionados"
                  @dadosPessoa='atualizarPessoa',
              )

          h2.text-left.pb-1 {{ $t('mensagens.territorio.informacoesEspaciais') }}
          .row.m-0.mb-3
              .col-4.formContainer
                  div(v-show='!isEdicaoSimplesTerritorio')
                        p {{ $t('mensagens.territorio.instrucaoUploadVetorParaguai') }}
                        p {{ $t('mensagens.territorio.uploadArquivosVetoriaisParaguai') }}
                        .row.m-0.d-flex.flex-row
                        el-upload.upload-demo(
                            drag,
                            :file-list='fileList',
                            action='alert',
                            :auto-upload='false',
                            :on-change='onLoadFile',
                            :limit='1',
                            :disabled='desligarUpload || hasTerritoryData',
                            :on-remove='onRemoveFile',
                            ref='upload',
                            accept='.wkt,.kml,.kmz,.shp,.zip'
                        )
                            i.el-icon-upload(style='margin-top: 40px')
                            .el-upload__text {{ $t('mensagens.territorio.dragAndDrop.1') }} <em>{{ $t('mensagens.territorio.dragAndDrop.2') }}</em>

                        el-button.primary-button(
                            v-if='arquivosUploads.length > 0 && (desligarDesenho && !desligarUpload)'
                            type='danger',
                            @click='handleRemoveFile'
                        )
                          div.mdi.mdi-delete
                           | {{ $t('mensagens.territorio.removerDesenhoParaguai') }}
                        el-divider(v-if='arquivosUploads.length === 0' content-position="center") {{ $t('mensagens.diagnosticoSocioambiental.ou') }}
                  div(v-if='isEdicaoSimplesTerritorio' class="div-texto-edicao")
                     span {{ territorio.territorioVega ? $t('mensagens.territorio.naoPossivelEditarGeometriaTerritorioVinculado') : $t('mensagens.territorio.paraEditarGeometriaFacaEdicaoCompleta') }}
                  div(v-show='!isEdicaoSimplesTerritorio && arquivosUploads.length === 0')
                     p {{ $t('mensagens.territorio.instrucaoDesenhoVetorParaguai') }}
                     el-button.primary-button(
                        v-if='hasTerritoryData || (desligarDesenho && desligarUpload)'
                        type='danger',
                        @click='removerDesenho'
                     )
                       div.mdi.mdi-delete
                        | {{ $t('mensagens.territorio.removerDesenhoParaguai') }}

                     el-button.primary-button(
                        v-if='!hasTerritoryData'
                        type='primary',
                        :disabled='desligarDesenho && !desligarUpload'
                        @click='desenhar'
                     )
                       div.mdi.mdi-pencil-outline
                        | {{ $t('mensagens.territorio.desenharParaguai') }}

              .col-8.pr-0
                  .mapa
                      mapa.map-content(
                          :mapLayersConfigs='layersMaps',
                          :mapConfig='isEdicaoSimplesTerritorio ? mapConfigEdicaoSimples : mapConfig',
                          :idMapa='"mapaAddTerritorio"',
                          :height='"625px"',
                          @draw-created='adicionarDesenho',
                          @draw-edited='desenhosAlterados',
                          @removerTerritorio='removerTerritorio',
                          :deslocarPopup='true',
                          :menuMaior='true',
                          :cadastroTerritorio='true',
                          :cadastroTerritorioParaguai='true'
                          :ligarDesenho='ligarDesenho'
                          :desligarDesenho='desligarDesenho'
                          :removerDesenhoParaguai='removerDesenhoParaguai'
                          ref='mapa'
                      )

          .row.m-0
              h2.section-title-info-cadastro.pb-1 {{ $t('mensagens.territorio.tituloUpload') }}
              UploadDocumentos(
                  v-for="documento in documentos"
                  :key="documento.id"
                  :class="documento.id === 1 ? 'm-0' : ''"
                  :tipoDocumento="documento"
                  :arquivosExistentes="arquivosExistentes"
                  @update-file-list="handleFileListUpdate"
              )

          .row.justify-content-end.py-3.m-0
              el-tooltip(
                  effect='dark',
                  :content="faltouVincularTerritorioVega ? $t('mensagens.territorio.territorioVegaSobreposto.informeUmTerritorioValido') : $t('mensagens.territorio.preenchaCamposObrigatorios')",
                  placement='top-start',
                  :class='{ "item btn-disabled": (this.$v.$invalid || this.territoryTableData.length !== 1 || this.territorioSobrePostoMessage) || faltouVincularTerritorioVega }',
                  :disabled='!(this.$v.$invalid || this.territoryTableData.length !== 1) && !faltouVincularTerritorioVega'
              )
                  el-button(
                      v-if='this.isAdding',
                      type='primary',
                      @click='addTerritorio',
                      style='width: 104px'
                  )
                        | {{ $t('mensagens.comuns.cadastrar')  }}
                  el-button(
                      v-else,
                      type='primary',
                      @click='updateTerritorio',
                      style='width: 80px'
                  )
                      | {{ $t('mensagens.comuns.salvar') }}

      div(v-if='mostrarModalDadosCpfCnpj')
          ModalSelecionarDadosCpfCnpj(
              :show='mostrarModalDadosCpfCnpj',
              :cpfCnpj='carVinculadoCpfCnpj',
              tipo='TERRITORIO',
              :dados='dados',
              @voltar='mostrarModalDadosCpfCnpj = false',
              @retornarDadosSelecionados='adicionarDadosSelecionadosNaModalNoMapa'
          )

      el-dialog.dialog-lista-select(
          :visible.sync='territorioSobrePosto',
          :title='$t("mensagens.territorio.territorioSobreposto")',
          :close-on-click-modal='false',
          :close-on-press-escape='true',
          :destroy-on-close='true',
          :show-close='true',
          width='30%'
      )
          p.pre-formatted {{ internacionalizarMensagens(this.territorioSobrePostoMessage) }}
          .d-flex.flex-direction.justify-content-between.posicao-botao
              el-button(slot='footer', size='mini', @click='closeDialog') {{ $t('mensagens.comuns.voltar') }}
              el-button(
                  slot='footer',
                  size='mini',
                  type='primary',
                  @click='continuarTerritorioSobreposto'
              ) {{ $t('mensagens.comuns.continuar') }}

      ModalRecriarMonitoramentos(
          :mostrar='showModalRecriarMonitoramentos',
          :data='getRecriarMonitoramentos',
          @fechar='showModalRecriarMonitoramentos = false',
          @finalizar='recriarMonitoramentos'
      )

      ModalErroRecriarMonitoramentos(
          :mostrar='showModalErroRecriarMonitoramentos',
          :data='monitoramentosComErro',
          @fechar='fecharModalErroRecriarMonitoramentos'
      )

      ModalDivergenciaLocalidade(
          :show='modalDivergenciaLocalidade',
          :indexTerritorioDivergente='indexTerritorioDivergente',
          @delete-upload-file='deleteUploadFile',
          @close='modalDivergenciaLocalidade = false'
      )

      ModalSobreposicaoTerritorioParaguai(
        v-if="showSobreposicaoTerritorioParaguai"
        :show='showSobreposicaoTerritorioParaguai',
        :geometriaTerritorioSobreposto='territorioSobrepostoParaguai',
        :geometriaTerritorio='territorio.geoJson'
        @voltar='showSobreposicaoTerritorioParaguai = false'
      )

      ModalSelecionarTerritorioVegaSobreposto(
        v-if="abrirModalTerritorioVegaSobreposto"
        :show='abrirModalTerritorioVegaSobreposto',
        :geometriaTerritorio='territorio.geoJson',
        :territoriosVegaSoprepostos='territoriosVegaSoprepostos',
        @voltar='abrirModalTerritorioVegaSobreposto = false',
        @salvar='vincularTerritorioVega'
      )
  </template>

  <script>
  import ModalRecriarMonitoramentos from '@/components/territorio/ModalRecriarMonitoramentos.vue';
  import ModalErroRecriarMonitoramentos from '@/components/territorio/ModalErroRecriarMonitoramentos.vue';
  import ModalDivergenciaLocalidade from '@/components/territorio/ModalDivergenciaLocalidade.vue';
  import { required } from 'vuelidate/lib/validators';
  import { get } from 'lodash';
  import L from 'leaflet';
  import { mapActions, mapGetters } from 'vuex';
  import BaseHeader from '@/components/BaseHeader';
  import EmptyResult from '@/components/EmptyResult';
  import territorioService from '@/services/TerritorioService';
  import TerritorioVegaService from '@/services/TerritorioVegaService';
  import LocalidadeService from '@/services/LocalidadeService';
  import representanteService from '@/services/RepresentanteService';
  import TerritorioArquivo from '@/services/TerritorioArquivo';
  import Mapa from '@/components/MapaLeaflet';
  import listAreasTable from '@/components/listAreasTable/ListAreasTable';
  import geometryConverter from '@/utils/conversorGeometrias';
  import formatters from '@/utils/formatters';
  import validators from '@/utils/validators';
  import geometryUtils from '@/utils/mapa/geometry.js';
  import ModalSelecionarCarsSobrepostos from '@/components/territorio/ModalSelecionarCarsSobrepostos';
  import mapaEstilos from '@/utils/mapa/mapa.estilos';
  import EventBus from '@/utils/eventBus';
  import InformacaoAgricola from '@/components/territorio/Informacao';
  import UploadDocumentos from '@/components/territorio/UploadDocumentos';
  import ModalSelecionarDadosCpfCnpj from '@/components/ModalSelecionarDadosCpfCnpj';
  import MunicipioService from '@/services/MunicipioService';
  import CarService from '@/services/car/CarService';
  import SigefService from '@/services/SigefService';
  import VincularPessoa from '@/components/territorio/VincularPessoa';
  import { formatFlag } from '@/utils/featureFlags/featureFlag';
  import { FeatureFlagConst } from '@/constants/FeatureFlag';
  import ModalSobreposicaoTerritorioParaguai from '../../components/territorio/ModalSobreposicaoTerritorioParaguai.vue';
  import ModalSelecionarTerritorioVegaSobreposto from '@/components/territorio/ModalSelecionarTerritorioVegaSobreposto.vue';

  export default {
      name: 'CadastroTerritorioVegaSemCar',
      components: {
          BaseHeader,
          EmptyResult,
          Mapa,
          listAreasTable,
          ModalSelecionarCarsSobrepostos,
          InformacaoAgricola,
          UploadDocumentos,
          ModalSelecionarDadosCpfCnpj,
          ModalRecriarMonitoramentos,
          ModalErroRecriarMonitoramentos,
          VincularPessoa,
          ModalDivergenciaLocalidade,
          ModalSobreposicaoTerritorioParaguai,
          ModalSelecionarTerritorioVegaSobreposto
      },
      data() {
          return {
              dataLoaded: false,
              isAdding: null,
              isAddingOrEditingTerritorio: true,
              isIgnoreSobreposition: false,
              territorio: {
                  nome: null,
                  representantes: [],
                  city: null,
                  state: null,
                  area: null,
                  comercializacoes: null,
                  informacoesAgricolas: null,
                  certificacoes: null,
                  idCliente: null,
                  arquivos: []
              },
              addTerritorioSuccess: false,
              selectedTerritorio: {},
              mapConfig: {
                  controls: {
                      zoomControl: true,
                      camadasControl: true,
                      popupControl: true,
                      drawControl: true,
                      fullscreen: true,
                      buscarCarControl: false
                  },
                  inspecionar: true,
                  dontZoomIn: true,
                  fitBounds: true,
                  addLimitesEstado: false
              },
              mapConfigEdicaoSimples: {
                  controls: {
                      zoomControl: true,
                      camadasControl: true,
                      popupControl: true,
                      drawControl: false,
                      fullscreen: true,
                      buscarCarControl: false
                  },
                  inspecionar: true,
                  dontZoomIn: true,
                  fitBounds: true,
                  addLimitesEstado: false
              },
              actionType: 'Cadastrar',
              estados: [],
              estadoSelecionado: null,
              municipios: [],
              municipioSelecionado: null,
              fileList: [],
              representanteData: [],
              representanteSelecionado: null,
              pageToFetch: 0,
              ativo: false,
              resultados: [],
              geometria: null,
              loading: false,
              options: [],
              sendToMonitormanetoModal: false,
              paginacao: {
                  paginaAtual: 1,
                  tamanhoPagina: 5
              },
              arquivosUploads: [],
              carsSet: [],
              carEspecificado: false,
              firstCarsSelected: [],
              carsCondicao: {},
              carByCode: '',
              gemotryByCarCode: '',
              geometryDesenho: '',
              carByGeometry: '',
              carSelected: '',
              dialogListaCarSelect: false,
              territorioSobrePosto: false,
              territorioSobrePostoMessage: null,
              territorioInicial: {},
              layersMaps: [],
              carCodigo: null,
              carsCpfCnpj: [],
              carVinculadoCpfCnpj: null,
              mostrarModalDadosCpfCnpj: false,
              municipioBuffer: {},
              dados: {
                  carEstadoPaginado: [],
                  existemDados: false
              },
              tipoCertificacao: [],
              showModalRecriarMonitoramentos: false,
              showModalErroRecriarMonitoramentos: false,
              isRecriarMonitoramentos: false,
              monitoramentosComErro: [],
              tipoCadastroIsDoc: false,
              tipoCadastroIsVetor: false,
              tipoCadastroIsCarSelecionado: false,
              localidadesNivel1: [],
              localidadeNivel1Selecionada: {},
              localidadesNivel2: [],
              localidadeNivel2Selecionada: {},
              ligarDesenho: false,
              desligarDesenho: false,
              desligarUpload: false,
              localizacaoTerritorioSessaoEspacial: null,
              modalDivergenciaLocalidade: false,
              indexTerritorioDivergente: 0,
              fileListPerType: {
                1: [],
                2: [],
                3: [],
                0: []
              },
              ff1183CodigoLyraTerritorio: this.$unleash.isEnabled(formatFlag(FeatureFlagConst.FF1183_CODIGO_LYRA_TERRITORIO)),
              representantesSelecionados: [],
              arquivosExistentes: [],
              documentos: [],
              showSobreposicaoTerritorioParaguai: false,
              territorioSobrepostoParaguai: [],
              naoPossuiSobreposicao: false,
              removerDesenhoParaguai: false,
              abrirModalTerritorioVegaSobreposto: false,
              possuiSobreposicaoTerritorioVega: false,
              vinculouTerritorioVega: false,
              territoriosVegaSoprepostos: []
          };
      },
      validations: {
          territorio: {
              nome: {
                  required
              }
          }
      },
      mounted() {
          this.fetchTerritorios();
          this.fetchRepresentantes();
          this.fetchTipoCertificacao();
          this.buscarTipoArquivos();

          this.buscarLocalidadeNivel1(5599).then(() => {
            if (this.territorioData.value === 'edit') {
                if (this.territorio.representantes.length > 0) {
                    this.representantesSelecionados = this.territorio.representantes;
                }
                if (this.territorio.arquivos.length > 0) {
                    this.arquivosExistentes = this.territorio.arquivos;
                }
                this.territorioInicial = this.territorioData.geometria;

                this.selecionarLocalidade();
                this.desativarDrawControl();
            }
        });

          this.$bus.$on('informacoes', data => {
                this.verificarEAtualizarInformacoesAgricolas(data);
          });

          if (this.$route.params.cadastrar) {
              this.mostrarModalEditarCadastrarRepresentante = true;
              this.editar = false;
              this.territorio.nome = this.$route.params.cadastrar;
          }

          const { getters } = this.$store;
          const representante = getters.representante;
          if (representante.id) {
              const repr = this.options.findIndex(
                  item => item.id === representante.id
              );
              if (repr) {
                  this.options.push({ ...representante });
              }
              if (
                  this.$route.params.cadastrar === 'pessoa' ||
                  this.territorioData.value === 'edit'
              ) {
                  this.territorio.nome = '';
                  this.territorio.representantes.push({ ...representante });
                  this.representantesSelecionados = this.territorio.representantes;
              } else {
                  this.territorio.nome = '';
                  this.territorio.representantes = '';
              }
          }
      },

      beforeDestroy() {
          this.setRepresentante({
              id: null,
              usuario: null,
              idUsuario: null,
              nomeRazaoSocial: null,
              cpfCnpj: null,
              idCliente: null,
              email: null,
              ativo: null,
              dataCadastro: null,
              dataAtualizacao: null,
              empresas: null,
              cpfCnpjCrypt: null,
              arquivos: []
          });
          this.$store.dispatch('setLimparCamadas', true);

          this.clearTerritorio({});

          this.setEdicaoSimplesTerritorio(null);

          this.setRecriarMonitoramentos([]);
      },

      created() {
          EventBus.$on(
              'mapa:desativar-se-ativo-selecao',
              this.desativarSelecaoSeAtivo
          );
          EventBus.$on('mapa:setar-car-especificado', this.setarCarEspecificado);
      },
      computed: {
          ...mapGetters([
              'territorioData',
              'isEdicaoSimplesTerritorio',
              'territoryTableData',
              'representante',
              'usuarioLogado',
              'getRecriarMonitoramentos'
          ]),
          pagedTableData() {
              return this.tableData.slice(
                  this.pageSize * this.page - this.pageSize,
                  this.pageSize * this.page
              );
          },
          tipoBotao() {
              return this.ativo ? 'default' : 'primary';
          },
          textoBotao() {
              return this.ativo
                  ? this.$t('mensagens.territorio.desativarSelecaoMapa')
                  : this.$t('mensagens.territorio.ativarSelecaoMapa');
          },
          hasTerritoryData() {
              return this.territoryTableData && this.territoryTableData.length > 0;
          },
          faltouVincularTerritorioVega() {
              return this.possuiSobreposicaoTerritorioVega && !this.vinculouTerritorioVega;
          }
      },
      watch: {
          search() {
              if (!this.search) {
                  this.total = this.tableData.length;
                  return this.tableData;
              }
              this.page = 1;
              this.total = this.pagedTableData.length;
              return this.tableData.filter(
                  data =>
                      !this.search ||
                      data.nomeRazaoSocial
                          .toLowerCase()
                          .includes(this.search.toLowerCase())
              );
          },
          async territoryTableData(oldVal, newVal) {
            this.modalDivergenciaLocalidade = false;
            if (newVal.length <= oldVal.length) {
              if (newVal.length > 0) {
                const ultimoTerritorioInserido = newVal[newVal.length - 1];
                this.localizacaoTerritorioSessaoEspacial = await LocalidadeService.findLocalizacaoPorGeometria(null, ultimoTerritorioInserido.geometry);

                if (this.localidadeNivel2Selecionada.id) {
                    if (this.localidadeNivel1Selecionada.id !== this.localizacaoTerritorioSessaoEspacial.data.idNivel1 || this.localidadeNivel2Selecionada.id !== this.localizacaoTerritorioSessaoEspacial.data.idNivel2) {
                        this.modalDivergenciaLocalidade = true;
                        this.indexTerritorioDivergente = newVal.length - 1;
                    }
                }

                await TerritorioVegaService
                    .validarSobreposicaoTerritorioVega(newVal[0].geometry)
                    .then(({ data }) => {
                        if (data) {
                            this.territoriosVegaSoprepostos = data;
                            this.abrirModalTerritorioVegaSobreposto = true;
                            this.possuiSobreposicaoTerritorioVega = true;
                            this.territorio.geoJson = newVal[0].geometry;
                        } else {
                            // reseta para caso adicione pela segunda vez
                            this.territorio.codigoLyra = null;
                            this.vinculouTerritorioVega = false;
                            this.possuiSobreposicaoTerritorioVega = false;
                        }
                    });
              }
            }
            this.fitBoundsGeometriasTabela();
          },
          carCodigo: function (value) {
              if (value.length > 0) {
                  let mascara = '';
                  value = value.replace(/[^\w\s]/gi, '');

                  if (value.length === 13) {
                      mascara = value;
                  } else if (value.length <= 14) {
                      mascara = formatters.numeralStringFormatToDocumento(value);
                  } else if (value.length > 14 && value.length <= 32) {
                      mascara = formatters.formatCodigoParcela(value);
                  } else {
                      mascara = formatters.formatCar(value);
                  }
                  this.carCodigo = mascara;
              }
          }
      },
      methods: {
          desenhar() {
            if (this.removerDesenhoParaguai === true) {
                this.removerDesenhoParaguai = false;
            }
            this.desligarUpload = true;
            if (this.ligarDesenho === false) {
                this.ligarDesenho = true;
            } else {
                this.ligarDesenho = false;
            }
          },
          removerDesenho() {
            if (this.desligarUpload === true) {
                this.desligarUpload = false;
            }
            this.clearTerritoryTableData();
            this.removerDesenhoParaguai = false;
            this.$nextTick(() => {
                this.removerDesenhoParaguai = true;
            });

            // remove possivel territorio vega vinculado
            this.territorio.codigoLyra = null;
            this.vinculouTerritorioVega = false;
            this.possuiSobreposicaoTerritorioVega = false;
            this.layersMaps = [];
          },
          clearTerritoryTableData() {
            this.$store.dispatch('clearTerritoryTableData');
          },
          fecharModalErroRecriarMonitoramentos() {
              this.showModalErroRecriarMonitoramentos = false;
              this.monitoramentosComErro = [];
              this.encerrarEdicao();
          },
          recriarMonitoramentos(value) {
              this.isRecriarMonitoramentos = value;
              this.salvarTerritorio();

          },
          verificaInputBarra(valor) {
              if (valor.includes('/')) {
                  this.territorio.idCliente = valor.replace(/\//g, '');
              }
          },
          setarCarEspecificado(state) {
              this.carEspecificado = state;
          },
          closeDialog() {
              this.territorioSobrePosto = false;
          },

          ...mapActions([
              'setRepresentante',
              'setEdicaoSimplesTerritorio',
              'setTerritoryTableData',
              'clearTerritoryTableData',
              'clearTerritorio',
              'replaceTerritoryTableData',
              'removeTerritoryTableData',
              'setRecriarMonitoramentos'
          ]),

          removerTerritorio(identificadorGeometria) {
              this.desligarDesenho = false;
              this.territoryTableData.forEach((item, index) => {
                  if (identificadorGeometria === item.identificadorGeometria) {
                      this.removeTerritoryTableData(index);
                  }
              });
              this.layersMaps = [];
              this.territorio.geometry = {};
          },

          fetchStates() {
              LocalidadeService.findEstados().then(({ data }) => {
                  this.estados = data;
              });
          },

          deleteUploadFile(name) {
              const removeFile = this.$refs.upload.uploadFiles.filter(
                  f => f.name === name
              )[0];
              this.$refs.upload.uploadFiles =
                  this.$refs.upload.uploadFiles.filter(f => f.name !== name);
              this.onRemoveFile(removeFile, null);
          },

          fetchTerritorios() {
              if (this.territorioData.value === 'edit') {
                  this.territorio = this.territorioData;
                  this.isAdding = false;
                  this.setMapGeometry();
                  if (this.isEdicaoSimplesTerritorio) {
                    this.mapConfig.controls.drawControl = false;
                  }
              } else {
                  this.clearAll();
                  this.isAdding = true;
              }
              this.dataLoaded = true;
          },

          async buscarTipoArquivos() {
            try {
                  const { data } = await TerritorioArquivo.findTipoArquivos();
                  this.documentos = data;
              } catch (error) {
                  this.$notify.error({
                      message: get(error, 'response.data.message', error.message)
                  });
              }
          },

          clearSobreposicaoTerritorio() {
              this.territorioSobrePostoMessage = null;
              this.territorioSobrePosto = false;
          },

          async addTerritorio() {
              this.$v.$touch();
              if (this.checkIfIsValid()) {
                  this.territorio.geoJson = this.territoryTableData[0].geometry;
                  this.firstCarsSelected = this.territoryTableData[0].firstCodigos;

                  this.clearSobreposicaoTerritorio();

                  await territorioService
                    .validarSobreposicaoTerritorioParaguai(this.territorio.geoJson)
                    .then(async (res) => {
                        if (res.data.possuiSobreposicao) {
                            this.naoPossuiSobreposicao = true;
                            this.territorioSobrepostoParaguai = res.data.sobreposicoes;
                            this.showSobreposicaoTerritorioParaguai = true;
                        } else {
                            this.naoPossuiSobreposicao = false;
                        }
                    })
                    .catch(error => {
                        this.$notify.error({
                            message: get(
                                error,
                                'response.data.message',
                                error.message
                            )
                        });
                    });

                  if (!this.naoPossuiSobreposicao) {
                    if (this.isIgnoreSobreposition) {
                        this.salvarTerritorio();
                    } else {
                        territorioService
                            .validarSobreposicaoTerritorio(this.territorio.geoJson)
                            .then(async () => {
                                this.salvarTerritorio();
                            })
                            .catch(error => {
                                const message = get(
                                    error,
                                    'response.data.message',
                                    error.message
                                );
                                this.territorioSobrePostoMessage = message;
                                this.territorioSobrePosto = true;
                            });
                    }
                  }
              }
          },

          async salvarTerritorio() {
              if (this.territorio.representantes.length > 0) {
                const territorioPapelPessoaInvalid = this.territorio.representantes.some(
                    representante => representante.territorioPapelPessoa === null
                );

                if (territorioPapelPessoaInvalid) {
                    this.$notify.error({
                        message: this.$t('mensagens.territorio.notificacao.territorioPapelPessoaInvalid')
                    });
                    return;
                }
              }

              // limpando requiredIds para retirar obrigatoriedade de documentos
              const requiredIds = [];

              const idsPresentes = this.territorio.arquivos
              .filter(arquivo => requiredIds.includes(arquivo.idTipoArquivo))
              .map(arquivo => arquivo.idTipoArquivo);

              const validaUploadArquivo = requiredIds.every(id => idsPresentes.includes(id));

              if (!validaUploadArquivo) {
                this.$notify.error({
                    message: this.$t('mensagens.territorio.notificacao.campoObrigatorioUpload')
                });
                return;
              }

              if (this.getRecriarMonitoramentos && this.getRecriarMonitoramentos.length > 0) {
                  if (this.showModalRecriarMonitoramentos) {
                      this.territorio.excluirMonitoramentos = true;
                      this.territorio.recriarMonitoramentos = this.isRecriarMonitoramentos;
                      this.showModalRecriarMonitoramentos = false;
                  } else {
                      this.showModalRecriarMonitoramentos = true;
                      return;
                  }
              }

              this.territorio.carsVinculados = [];
              this.territorio.validarSobreposicao = !this.isIgnoreSobreposition;

              if (this.territorioData.value === 'edit') {
                  territorioService
                      .update(this.territorio)
                      .then(response => {
                          this.encerrarEdicao();
                      })
                      .catch(error => {
                          if (error.response.data && error.response.data.length > 0) {
                              this.monitoramentosComErro = error.response.data;
                              this.showModalErroRecriarMonitoramentos = true;
                              return;
                          }

                          this.$notify.error({
                              message: get(
                                  error,
                                  'response.data.message',
                                  error.message
                              )
                          });
                      });
              } else {
                  try {
                      await territorioService.add(
                          this.territorio
                      );

                      this.isAddingOrEditingTerritorio = false;
                      this.addTerritorioSuccess = true;
                      this.territorio.representantes = [];

                      this.$notify.success({
                          message: this.$t('mensagens.territorio.territorioAdicionadoSucesso')
                      });

                      this.$router.push({ name: 'Territorio' });
                  } catch (erro) {
                      this.$notify.error({
                          message: erro.response.data.message.includes(
                              this.$t('mensagens.territorio.geometriaNaoValida')
                          )
                              ? this.$t('mensagens.territorio.erroCadastroTerritorioGeometriaInvalida')
                              : erro.response.data.message.includes(
                                  this.$t('mensagens.territorio.idClienteJaExiste')
                              )
                                  ? this.$t('mensagens.territorio.idClienteJaExiste')
                                  : this.$t('mensagens.territorio.erroAoSalvarTerritorio')
                      });
                  }
              }
          },

          encerrarEdicao() {
              this.updateTerritorioModal = false;
              this.isAddingOrEditingTerritorio = false;
              this.fetchTerritorios();
              this.$notify.success({
                  message: 'Território editado com sucesso!'
              });
              this.$router.push({ name: 'Territorio' });
          },

          async continuarTerritorioSobreposto() {
              this.isIgnoreSobreposition = true;
              this.clearSobreposicaoTerritorio();
              this.addTerritorio();
              this.closeDialog();
          },

          async updateTerritorio() {
              this.$v.$touch();

              if (this.checkIfIsValid()) {
                  this.territorio.geoJson = this.territoryTableData[0].geometry;
                  this.territorio.informacoesAgricolas = this.territorio.informacoesAgricolas.map(info => {
                    const { cultura, ...rest } = info;
                    return {
                        ...rest,
                        idCultura: cultura?.id || null
                    };
                  });
                  if (this.isEdicaoSimplesTerritorio) {
                      this.territorio.carsVinculados = null;
                      this.isIgnoreSobreposition = true;
                      this.salvarTerritorio();
                      return;
                  }

                  if (!(this.territorioInicial === this.territorio.geoJson)) {
                    await territorioService
                    .validarSobreposicaoTerritorioParaguai(this.territorio.geoJson, this.territorio.id)
                    .then(async (res) => {
                        if (res.data.possuiSobreposicao) {
                            this.naoPossuiSobreposicao = true;
                            this.territorioSobrepostoParaguai = res.data.sobreposicoes;
                            this.showSobreposicaoTerritorioParaguai = true;
                        } else {
                            this.naoPossuiSobreposicao = false;
                        }
                    })
                    .catch(error => {
                        this.$notify.error({
                            message: get(
                                error,
                                'response.data.message',
                                error.message
                            )
                        });
                    });
                  } else {
                    this.salvarTerritorio();
                    return;
                  }

                  if (!this.naoPossuiSobreposicao) {
                    territorioService
                      .validarSobreposicaoTerritorio(
                          this.territorio.geoJson,
                          this.territorio.id
                      )
                      .then(async () => {
                        this.salvarTerritorio();
                      })
                      .catch(error => {
                          const message = get(
                              error,
                              'response.data.message',
                              error.message
                          );
                          this.territorioSobrePostoMessage = message;
                          this.territorioSobrePosto = true;
                          this.$notify.error({
                              message: error.response.data.mensagem.includes(
                                  'ID Cliente já existente'
                              )
                                  ? 'ID Cliente já existente'
                                  : 'Ocorreu um erro ao atualizar território.'
                          });
                      });
                  }
              }
          },

          findMunicipios(idEstado) {
              this.municipioSelecionado = null;
              this.municipios = null;
              if (idEstado != null) {
                  LocalidadeService.findMunicipios(idEstado).then(({ data }) => {
                      this.municipios = data;
                  });
              }
          },

          onLoadFile(file, fileList) {
              if (this.removerDesenhoParaguai === true) {
                this.removerDesenhoParaguai = false;
              }

              const formatosValidos = ['wkt', 'kml', 'kmz', 'shp', 'zip'];
              let extension = file.name.split('.').pop().toLowerCase();

              if (!formatosValidos.includes(extension)) {
                  this.$refs.upload.clearFiles();
                  this.$notify.error({ message: this.$t('mensagens.territorio.arquivoFormatoInvalido') });
                  return;
              }

              this.tipoCadastroIsVetor = true;
              this.$store.dispatch('processarEventoGoogleAnalytics', { eventLabel: 'INSERIR_KML_KMZ_WKT_SHAPEFILE', pageTitle: 'INSERIR_KML_KMZ_WKT_SHAPEFILE', routeName: this.$route?.name, routePath: this.$route?.path });
              let reader = new FileReader();

              reader.onload = async e => {
                  geometryConverter
                      .read(extension, e.target.result, file.raw)
                      .then(geometria => {
                          this.filtrarGeometrias(geometria);

                          if (geometria !== null && this.contarPoligonos(geometria) > 1) {
                              this.$refs.upload.clearFiles();
                              this.$notify.error({ message: this.$t('mensagens.territorio.multiPolygonNaoPermitido') });
                              return;
                          }

                          this.processarGeometria(geometria, file.name);

                          let dadosArquivo = {
                              id: file.uid,
                              layer: geometria
                          };

                          this.arquivosUploads.push(dadosArquivo);
                      })
                      .catch(rejectReason => {
                          this.$refs.upload.clearFiles();
                          this.$notify.error({ message: rejectReason });
                      });
              };

              reader.readAsText(file.raw);
              this.desligarDesenho = true;
          },

          processarGeometria(geometria, fileName) {
              if (geometria !== null && geometria.getLayers().length > 0) {
                  if (
                      geometria.getLayers()[0].feature.geometry.type ===
                      'GeometryCollection'
                  ) {
                      _.each(geometria.getLayers()[0].getLayers(), layer =>
                          this.processarLayer(geometria, layer, fileName)
                      );
                  } else {
                      _.each(geometria.getLayers(), layer => {
                          if (layer.feature.geometry.type !== 'GeometryCollection') {
                              this.processarLayer(geometria, layer, fileName);
                          }
                      }

                      );
                  }
              } else {
                  this.$refs.upload.clearFiles();

                  this.$notify.error({
                      message: this.$t('mensagens.territorio.arquivoNaoPossuiGeometriaValida')
                  });
              }
          },

          async processarLayer(geometria, layer, fileName) {
              let territoryPropertyConverionToTableData = {};
              territoryPropertyConverionToTableData.identificadorGeometria =
                  layer._leaflet_id;
              layer.identificadorGeometria = layer._leaflet_id;
              territoryPropertyConverionToTableData.type = 'UPLOAD';
              territoryPropertyConverionToTableData.codigo = 'UPLOAD';
              territoryPropertyConverionToTableData.area_ha =
                  geometryUtils.calcularAreaHaFromLayer(layer);
              territoryPropertyConverionToTableData.geometry =
                  layer.toGeoJSON().geometry;
              territoryPropertyConverionToTableData.fileName = fileName;

              this.setTerritoryTableData(territoryPropertyConverionToTableData);
              this.clearSobreposicaoTerritorio();

              const uploadStyle = {
                  color: '#bada55',
                  fillOpacity: 0
              };

              geometria.setStyle(uploadStyle);

              this.$refs.mapa.mapa.addLayer(geometria);
              this.$refs.mapa.mapa.fitBounds(geometria.getBounds());
          },
          contarPoligonos(layerGroup) {
              let count = 0;
              if (layerGroup.getLayers) {
                  layerGroup.getLayers().forEach(layer => {
                      if (layer instanceof L.Polygon) {
                          count++;
                      } else if (layer instanceof L.LayerGroup) {
                          count += this.contarPoligonos(layer);
                      }
                  });
              }
              return count;
          },
          /* Permite apenas Features e Geometries do tipo '(Multi)Polygon' */
          filtrarGeometrias(layerGeometrias) {
              if (layerGeometrias === null) return;

              if (layerGeometrias.getLayers) {
                  layerGeometrias.getLayers().forEach(layer => {
                      if (!(layer instanceof L.Polygon)) {
                          if (layer instanceof L.LayerGroup) {
                              return this.filtrarGeometrias(layer);
                          }
                          layerGeometrias.removeLayer(layer);
                      }
                  });
              } else {
                  if (!(layerGeometrias instanceof L.Polygon)) {
                      return L.featureGroup();
                  }
              }
          },
          handleRemoveFile() {
            const fileList = this.$refs.upload.uploadFiles;

            if (fileList.length > 0) {
            const fileToRemove = fileList[0];
            this.onRemoveFile(fileToRemove);
            this.territorio.geoJson = null;
            }

            // remove possivel territorio vega vinculado
            this.territorio.codigoLyra = null;
            this.vinculouTerritorioVega = false;
            this.possuiSobreposicaoTerritorioVega = false;
            this.layersMaps = [];
          },
          onRemoveFile(file, fileList) {
              this.desligarDesenho = false;

              const uploadRef = this.$refs.upload;
              const refToRemove = uploadRef.uploadFiles.findIndex(f => f.uid === file.uid);
              if (refToRemove !== -1) {
                uploadRef.uploadFiles.splice(refToRemove, 1);
              }

              let itemToRemove = _.find(this.arquivosUploads, o => {
                  return o.uid === file.id;
              });

              if (itemToRemove) {
                  this.$refs.mapa.mapa.removeLayer(itemToRemove.layer);
              }

              _.remove(this.arquivosUploads, o => {
                  return o.uid === file.id;
              });
              const index = this.territoryTableData.findIndex(
                  d => d.fileName === file.name
              );
              this.removeTerritoryTableData(index);
          },

          getFiltros(query) {
              const filtro = {};
              filtro.page = this.paginacao.paginaAtual - 1;
              filtro.size = this.paginacao.tamanhoPagina;
              filtro.searchText = query || '';
              if (validators.validarCPF(query)) {
                  filtro.searchText = formatters.documentoFormatToNumeral(query);
              }
              filtro.order = '&sort=nome_razao_social,asc';
              return filtro;
          },

          async fetchRepresentantes(query) {
              try {
                  const { data } = await representanteService.findAllByFiltro(
                      this.getFiltros(query)
                  );
                  this.loading = false;
                  this.representanteData = this.representanteData.concat(
                      data.resultados
                  );
                  this.representanteData = this.representanteData.filter(
                      (v, i, a) => a.findIndex(t => t.id === v.id) === i
                  );
                  this.options = data.resultados.slice(0, 5);
                  if (this.territorioData.value === 'edit') {
                      let intersection = [];
                      let difference = [];
                      this.options.forEach(value => {
                          this.territorio.representantes.forEach(item => {
                              if (item.id === value.id) {
                                  intersection.push(item);
                              }
                          });
                      });
                      difference = this.territorio.representantes.filter(
                          value => !intersection.includes(value)
                      );
                      this.options.push(...difference);
                  }

                  if (this.representante.id) {
                      const repr = this.options.findIndex(
                          item => item.id === this.representante.id
                      );
                      if (repr) {
                          this.options.push({ ...this.representante });
                      }
                  }
              } catch (e) {
                  this.$notify.error({
                      message: this.$t('mensagens.territorio.erroAoBuscarPessoas')
                  });
              }
          },

          async fetchTipoCertificacao() {
              try {
                  const { data } =
                      await territorioService.buscarTipoCertificacao();
                  this.tipoCertificacao = data;
              } catch (e) {
                  this.$notify.error({
                      message: this.$t('mensagens.territorio.erroAoBuscarTiposCertificacao')
                  });
              }
          },

          toggleSelecao() {
              this.tipoCadastroIsCarSelecionado = true;
              this.$store.dispatch('processarEventoGoogleAnalytics', { eventLabel: 'INSERIR_CAR_SELECAO_MAPA', pageTitle: 'INSERIR_CAR_SELECAO_MAPA', routeName: this.$route?.name, routePath: this.$route?.path });
              this.ativo = !this.ativo;
              if (this.ativo) {
                  this.ativarSelecao();
              } else {
                  this.desativarSelecao();
              }
          },
          desativarSelecaoSeAtivo() {
              if (this.ativo) {
                  this.desativarSelecao();
                  this.ativo = false;
              }
          },
          ativarSelecao() {
              this.$store.dispatch('setAtivarCamadaCar', true);
          },
          desativarSelecao() {
              this.$store.dispatch('setAtivarCamadaCar', false);
              this.territorio.geoJson = null;
              this.fitBoundsGeometriasTabela();
          },
          fitBoundsGeometriasTabela() {
              if (
                  this.territoryTableData.length &&
                  this.$refs &&
                  this.$refs.mapa &&
                  this.$refs.mapa.mapa
              ) {
                  const group = new L.FeatureGroup();
                  this.territoryTableData.forEach(territorioTabela => {
                      group.addLayer(L.geoJSON(territorioTabela.geometry));
                  });
                  this.$refs.mapa.mapa.fitBounds(group.getBounds());
              }
          },
          setMapGeometry() {
              const identificadorGeometria = new Date().getTime();

              const territoryPropertyConverionToTableData = {};
              territoryPropertyConverionToTableData.type = 'AREA_CONSOLIDADA';
              territoryPropertyConverionToTableData.codigo = 'AREA_CONSOLIDADA';
              territoryPropertyConverionToTableData.area_ha =
                  this.territorioData.areaHa;
              territoryPropertyConverionToTableData.geometry =
                  this.territorioData.geometria;
              territoryPropertyConverionToTableData.identificadorGeometria =
                  identificadorGeometria;

              this.clearTerritoryTableData();
              this.setTerritoryTableData(territoryPropertyConverionToTableData);
              this.clearSobreposicaoTerritorio();

              this.mostrarTerritorioNoMapa(
                  this.territorioData.geometria,
                  identificadorGeometria
              );
          },

          mostrarTerritorioNoMapa(geometria, identificadorGeometria) {
            this.layersMaps = [];

            geometria.identificadorGeometria = identificadorGeometria;

            const layerTerritorio = {
                style: mapaEstilos.Geometria.imovelRuralCandidatoParaguai,
                name: identificadorGeometria,
                geoJson: geometria
            };

            this.layersMaps.push(layerTerritorio);

            this.$nextTick(() => {
                const bounds = L.geoJSON(geometria).getBounds();
                if (this.$refs.mapa && this.$refs.mapa.mapa) {
                    this.$refs.mapa.mapa.fitBounds(bounds);
                }
            });
          },
          clearAll() {
              this.clearTerritoryTableData();
              this.territorio.nome = null;
              this.clearTerritorio();
          },
          remoteMethod(query) {
              this.loading = true;
              setTimeout(() => {
                  this.fetchRepresentantes(query);
              }, 800);
          },
          dadoJaFoiAdicionado(dado) {
              let result = false;
              if (this.territoryTableData.length === 0) {
                  result = false;
              } else {
                  this.territoryTableData.forEach(item => {
                      if (item.codigo === dado) {
                          result = true;
                      }
                  });
              }
              return result;
          },

          async getDadosMunicipio(item) {
              const idMunicipio = item.properties.id_municipio;

              if (this.municipioBuffer[idMunicipio]) {
                  return `${this.municipioBuffer[idMunicipio].nome} - ${this.municipioBuffer[idMunicipio].estado.sigla}`;
              } else {
                  try {
                      const { data } = await MunicipioService.getMunicipioById(
                          idMunicipio
                      );
                      this.municipioBuffer[idMunicipio] = data;
                      return `${this.municipioBuffer[idMunicipio].nome} - ${this.municipioBuffer[idMunicipio].estado.sigla}`;
                  } catch (e) {
                      this.$notify.error({
                          message: this.$t('mensagens.territorio.erroAoBuscarDadosMunicipio')
                      });
                      return '-';
                  }
              }
          },
          adicionarDadosSelecionadosNaModalNoMapa(dadosSelecionados) {
              this.mostrarModalDadosCpfCnpj = false;
              this.layersMaps = [];

              Object.keys(dadosSelecionados).forEach(conjunto => {
                  if (conjunto === 'sigef') {
                      dadosSelecionados[conjunto].forEach(
                          async ({ codigoParcela }) => {
                              const { data } =
                                  await SigefService.buscarGeometriaParcela(
                                      codigoParcela
                                  );

                              const geometriaParcela = JSON.parse(data);

                              const resultado = {
                                  codigo: codigoParcela,
                                  identificadorGeometria: codigoParcela,
                                  type: 'Parcela Incra',
                                  geometry: geometriaParcela,
                                  area_ha:
                                      geometryUtils.calcularAreaHaFromGeoJSON(
                                          geometriaParcela
                                      )
                              };

                              this.mostrarTerritorioNoMapa(
                                  geometriaParcela,
                                  resultado.identificadorGeometria
                              );

                              if (!this.dadoJaFoiAdicionado(codigoParcela)) {
                                  this.setTerritoryTableData(resultado);
                              }
                          }
                      );
                  } else {
                      dadosSelecionados[conjunto].forEach(async ({ codigo }) => {
                          const { data } = await CarService.buscarGeometria(
                              codigo
                          );

                          const resultado = {
                              codigo,
                              identificadorGeometria: codigo,
                              type: 'CAR',
                              geometry: data,
                              area_ha:
                                  geometryUtils.calcularAreaHaFromGeoJSON(
                                      data
                                  )
                          };

                          this.mostrarTerritorioNoMapa(
                              data,
                              resultado.identificadorGeometria
                          );

                          if (!this.dadoJaFoiAdicionado(codigo)) {
                              this.setTerritoryTableData(resultado);
                          }
                      });
                  }
              });

              this.carCodigo = null;
          },
          handleChangeSelectInput() {
              this.$nextTick(() => {
                  this.$refs.elselectinput.query = '';
              });
          },
          checkIfIsValid() {
              if (this.$v.$invalid || this.territoryTableData.length !== 1) {
                  if (this.$v.$invalid) {
                      this.$notify.error({
                          message: this.$t('mensagens.territorio.verifiqueCamposObrigatorios')
                      });
                      return false;
                  }
                  if (
                      this.territoryTableData.length !== 1 &&
                      !this.isEdicaoSimplesTerritorio
                  ) {
                      setTimeout(() => {
                          this.$notify.error({
                              message: this.$t('mensagens.territorio.naoPermitidoTerritorioComVariosPoligonos'),
                              duration: 20000
                          });
                      }, 200);
                      return false;
                  }
              }
              if (this.territorioSobrePostoMessage) {
                  this.territorioSobrePosto = true;
                  return false;
              }
              if (this.faltouVincularTerritorioVega) {
                this.$notify.error({
                    message: this.$t('mensagens.territorio.territorioVegaSobreposto.naoVinculouTerritorioVega')
                });
                return false;
              }

              return true;
          },
          async adicionarDesenho(desenho) {
              let territoryPropertyConverionToTableData = {};
              territoryPropertyConverionToTableData.identificadorGeometria =
                  desenho._leaflet_id;
              desenho.identificadorGeometria = desenho._leaflet_id;

              territoryPropertyConverionToTableData.type = 'Desenho de geometria';
              territoryPropertyConverionToTableData.codigo = 'DESENHO';
              territoryPropertyConverionToTableData.area_ha =
                  geometryUtils.calcularAreaHaFromLayer(desenho);
              territoryPropertyConverionToTableData.geometry =
                  desenho.toGeoJSON().geometry;

              this.geometryDesenho = desenho.toGeoJSON().geometry;
              this.setTerritoryTableData(territoryPropertyConverionToTableData);
              this.clearSobreposicaoTerritorio();
              this.desativarDrawControl();
          },
          desativarDrawControl() {
            this.desligarDesenho = true;
          },
          desenhosAlterados(desenhosAlterados) {
              desenhosAlterados.eachLayer(layer => {
                  const areaHa = geometryUtils.calcularAreaHaFromLayer(layer);
                  const geometry = layer.toGeoJSON().geometry;
                  this.territoryTableData.findIndex(
                      t => t.identificadorGeometria === layer._leaflet_id
                  );
                  this.replaceTerritoryTableData({
                      identificadorGeometria: layer._leaflet_id,
                      geometry,
                      areaHa
                  });
              });
          },

          verificarEAtualizarInformacoesAgricolas(data) {
            data.forEach((item) => {
                if (item.cultura && typeof item.cultura.id === 'number') {
                item.idCultura = item.cultura.id;
                }

                item.areaPlantadaHa = Number(item.areaPlantadaHa) || null;
            });

            this.territorio.informacoesAgricolas = data;
          },

          async buscarSigefPorCodigoParcela() {
              const { data } = await SigefService.buscarGeometriaParcela(
                  this.carCodigo
              );

              const geometriaParcela = JSON.parse(data);

              if (data === '') {
                  this.$notify.warning(
                      this.$t('mensagens.territorio.erroParcelaInseridaNaoEncontrada')
                  );
                  return;
              }

              const resultado = {
                  codigo: this.carCodigo,
                  identificadorGeometria: this.carCodigo,
                  type: 'Parcela Incra',
                  geometry: geometriaParcela,
                  area_ha:
                      geometryUtils.calcularAreaHaFromGeoJSON(geometriaParcela)
              };

              this.mostrarTerritorioNoMapa(
                  geometriaParcela,
                  resultado.identificadorGeometria
              );

              if (!this.dadoJaFoiAdicionado(this.carCodigo)) {
                  this.setTerritoryTableData(resultado);
              }
          },

          async buscarLocalidadeNivel1(idLocalidadeNivel0) {
            const { data } = await LocalidadeService.findNivel1(idLocalidadeNivel0);
            this.localidadesNivel1 = data;
          },

          async buscarLocalidadeNivel2() {
            const { data } = await LocalidadeService.findNivel2(this.localidadeNivel1Selecionada.id);
            this.localidadesNivel2 = data;
          },

          atualizarPessoa(pessoasVinculadas) {
            this.territorio.representantes = pessoasVinculadas;
          },
          handleFileListUpdate({ tipo, fileList }) {
            this.$set(this.fileListPerType, tipo, fileList);

            let lista = Object.values(this.fileListPerType)
                .flat()
                .map(item => {
                    const { idTipoArquivo, ...resto } = item;
                    return {
                        nomeArquivo: resto.name,
                        idTipoArquivo
                    };
                });

            if (fileList.length === 0) {
                this.territorio.arquivos = this.territorio.arquivos.filter(
                    arquivo => arquivo.idTipoArquivo !== tipo.id
                );
            } else {
                this.territorio.arquivos = this.territorio.arquivos.filter(
                    arquivo => arquivo.idTipoArquivo !== tipo.id
                );

                this.territorio.arquivos.push(...lista);
                this.fileListPerType = {};
            }
          },
         internacionalizarMensagens(message) {
            if (!message) {
                return '';
            }
            const partes = message.split('\n');
            const territoriosSobrepostos = partes.slice(1, -1).join('\n').trim();
            const mensagemSobreposicao = this.$t('mensagens.territorio.avisoSobreposicaoTerritorios');
            const mensagemConfirmarSobreposicao = this.$t('mensagens.territorio.confirmarCadastroSobreposto');

            return `${mensagemSobreposicao}\n ${territoriosSobrepostos}\n${mensagemConfirmarSobreposicao}`;
        },
        async buscarLocalizacao() {
            const response = await LocalidadeService.findLocalizacaoPorId(this.localidadeNivel2Selecionada.id);
            const bounds = L.geoJSON(response.data.geometria).getBounds();
            this.$refs.mapa.mapa.flyToBounds(bounds);
        },
        async selecionarLocalidade() {
            if (!this.territorioData.localidade) return;

            const [nomeLocalidade, sigla] = this.territorioData.localidade.split(' - ').map(item => item.trim());
            const localidadeNivel1 = this.localidadesNivel1.find(item => item.sigla === sigla);

            if (localidadeNivel1) {
                this.localidadeNivel1Selecionada = localidadeNivel1;

                await this.buscarLocalidadeNivel2();
                const localidadeNivel2 = this.localidadesNivel2.find(item => item.nome === nomeLocalidade);

                if (localidadeNivel2) {
                    this.localidadeNivel2Selecionada = localidadeNivel2;
                }
            }
        },
        vincularTerritorioVega(territorioVega) {
            this.abrirModalTerritorioVegaSobreposto = false;
            if (this.arquivosUploads.length > 0) {
                const fileList = this.$refs.upload.uploadFiles;
                const file = fileList[0];
                let itemToRemove = _.find(this.arquivosUploads, o => {
                  return o.uid === file.id;
                });

                if (itemToRemove) {
                    this.$refs.mapa.mapa.removeLayer(itemToRemove.layer);
                }
                const identificadorGeometria = new Date().getTime();
                this.mostrarTerritorioNoMapa(territorioVega.geom, identificadorGeometria);

                this.$nextTick(() => {
                    const identificadorGeometria = new Date().getTime();
                    this.mostrarTerritorioNoMapa(territorioVega.geom, identificadorGeometria);
                    this.desligarDesenho = true;
                });

            } else {
                this.layersMaps = [];
                this.$nextTick(() => {
                    const identificadorGeometria = new Date().getTime();
                    this.mostrarTerritorioNoMapa(territorioVega.geom, identificadorGeometria);
                    this.desligarDesenho = true;
                });
            }
            this.territorio.geoJson = territorioVega.geom;
            this.territorio.codigoLyra = territorioVega.codigo;
            this.vinculouTerritorioVega = true;
            this.territoryTableData[0].geometry = territorioVega.geom;
        }
      }
  };
  </script>

  <style lang='scss' scoped>
  .cadastro-territorio {
      display: flex;
      flex-direction: column;

      button {
          width: fit-content;
          cursor: pointer;
      }

      .required-text {
          color: var(--danger);
      }

      .m-25 {
          margin-top: 25px;
      }
  }

  .posicao-botao {
      display: flex;
      justify-content: space-between;
  }

  .formContainer {
      background-color: var(--white);
      border-radius: 5px;
      padding: 20px;
  }

  .el-upload {
      flex: 1;

      .el-icon-upload {
          font-size: 40px;
          margin: 0px;
      }
  }

  .el-collapse-item {
      border-bottom: 1px solid #ebeef5;
  }

  .el-upload-dragger {
      width: 100%;
      height: 80px;
      display: flex;
      align-items: center !important;
      justify-content: center !important;
      flex-direction: column !important;
  }

  .el-form-item__label {
      margin-bottom: 0px;
  }

  .left .el-tooltip__popper,
  .right .el-tooltip__popper {
      padding: 8px 10px;
  }

  .voltar {
      cursor: pointer;
      line-height: 2;
  }

  .mapa {
      border-radius: 4px;
      overflow: hidden;
  }

  .btn-selecao-mapa-body {
      display: flex;
      justify-content: center;
      align-items: center;

      i {
          margin-right: 5px;
      }
  }

  .pre-formatted {
      white-space: pre-line;
      word-break: break-word;
  }

  .form-size {
      width: 100%;
  }

  .form-alignment {
      display: flex;
      align-items: center;
  }

  .separator {
      margin-right: 20px;
  }

  .localidades-territorio-paraguai {
      width: 100%;
      display: flex;
  }

  .select-flex {
      width: 30%;
      display: flex;
      flex-direction: Column;
  }

  .select-flex-60 {
      width: 62%;
      display: flex;
      flex-direction: Column;
  }

  .section-title-info-cadastro {
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    color: #3B3B3B;
  }

  .titulo-territorio {
    font-size: 14px;
  }

  .no-padding {
    padding: 0px;
  }

  .primary-button {
    display: flex;
    justify-content: center;
    gap: 5px;
    width: 100%;
    font: 500 14px/143% Roboto, sans-serif !important;

    .mdi.mdi-pencil-outline::before {
        padding: 5px;
      }
    }
  </style>

  <style lang='scss'>
  .menu-lateral-bg {
      background-color: var(--primary) !important;
      height: 100%;
      box-shadow: -11px 3px 33px -8px rgba(0, 0, 0, 0.25);
      padding-left: 8px;
  }

  #botao-ferramentas>span>.el-icon-s-tools {
      margin-top: -5px;
      margin-left: -8px;

      &::before {
          font-size: 20px;
      }
  }

  .div-texto-edicao {
    height: 100%;
    width: 100%;
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    justify-content: center;
  }

  .div-texto-edicao span {
    font-size: 20px;
  }
  </style>
